var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.333,
    height: 16,
    viewBox: "0 0 27.333 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-seta-down-small",
    transform: "translate(0 16) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-seta-down-small-2",
    "data-name": "icon-seta-down-small",
    d: "M8.14,0V25.716l6.584-6.07.651.6L7.688,27.333,0,20.245l.651-.6,6.584,6.071V0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrowWhite);
export default __webpack_public_path__ + "static/media/btn-arrow-white.c2eebcdc8fbb7740a304411cc02a3324.svg";
export { ForwardRef as ReactComponent };